import type { Map as MLMap } from 'maplibre-gl';

/**
 * Shared container key used to expose the mounted MapLibre instance so
 * interleaved secondary adapters (deck.gl) can attach to the same map.
 */
export const MAPLIBRE_HOST_HANDLE_KEY = '__geosoft_maplibre_instance';

export function setMapLibreHostHandle(container: HTMLElement, map: MLMap): void {
  (container as unknown as Record<string, unknown>)[MAPLIBRE_HOST_HANDLE_KEY] = map;
}

export function getMapLibreHostHandle(container: HTMLElement): MLMap | null {
  const value = (container as unknown as Record<string, unknown>)[MAPLIBRE_HOST_HANDLE_KEY];
  return value ? (value as MLMap) : null;
}

export function clearMapLibreHostHandle(container: HTMLElement): void {
  delete (container as unknown as Record<string, unknown>)[MAPLIBRE_HOST_HANDLE_KEY];
}
